"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMortgageInput = void 0;
var MortgageCommonState_init_1 = require("@/pages/mortagage/states/MortgageCommonState.init");
exports.getMortgageInput = function (state) {
    var d = MortgageCommonState_init_1.defaultMortgageCommonState;
    return {
        propertyValue: state.price,
        downPayment: state.downPayment,
        tenor: state.durationInMonth / 12,
        interestRate: state.interestRate,
        buyerStampDuty: state.buyerStampDuty,
        adValoremStampDuty: state.adValoremStampDuty,
        hasOutstandingMortgage: state.hasOutstandingMortgage,
        lastTransactionInMonth: state.hasTransactedRecently ? state.hasTransactedRecentlyMonth : -1,
        commissionRate: d.commissionRate,
        buyerStampDutyRate: d.buyerStampDutyRate,
        adValoremStampDutyRate: d.adValoremStampDutyRate,
        specialStampDutyRateTable: d.specialStampDutyRateTable,
        doubleAdValoremStampDutyRateTable: d.doubleAdValoremStampDutyRateTable,
        mortgagePlanList: d.mortgageInsuranceSetting,
        mortgagePlanListWithProperty: d.mortgageInsuranceSettingWithProperty,
        mortgageLimitTable: d.mortgageLimitTable,
        legalAmount: d.legalAmount,
        isInsuranceMonthlyRepay: d.isInsuranceMonthlyRepay,
        rateTableInputs: d.rateTableInputs,
    };
};
